

  /*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

  import { Injectable } from '@angular/core';
  import { Observable } from 'rxjs';
  import { HttpService } from './http.service';
  import { HttpHeaders, HttpParams } from '@angular/common/http';
  import {CollectionReport } from '../../../interfaces/report/collectionReport';
  
  @Injectable()
  export class CollectionReportApi {
   // private readonly apiController: string = 'tenants/';
  
    constructor(private api: HttpService) { }
  
    list(url: string, queryParams?: HttpParams): Observable<any[]> {
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      //header.append('Content-Type', 'applications/json');
      //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
      //header.append('Accept','application/vnd.ezovion.hateoas+json');
      if(!!queryParams){
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"},params:queryParams});
      }
      else{
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
      }
    }
  
    getById(url : string, options?: any): Observable<CollectionReport> {
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directGet(url,header);
    }
  
    add(url:string, data: CollectionReport):Observable<CollectionReport[]>{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPost(url, data, header);
    }
    addLabMaster(url:string, data: any):Observable<any>{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPost(url, data, header);
    }
  
    update(url:string, data: CollectionReport):Observable<CollectionReport[]>{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut(url, data, header);
    }
    updateLabMaster(url:string, data: any):Observable<any>{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut(url, data, header);
    }
  
    delete(url: string):Observable<any>{
      return this.api.directDelete(url);
    }
    searchList(url: string, data:any, options?: any): Observable<any[]> {
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
  }
  